import { instance } from "libs/api";

import { Category } from "../../categories.types";
import { ApiRoutesCategories } from "./../../constants";
import { CreateCategoryRequestBody } from "./createCategory.types";

export const requestCreateCategory = async (
  body: CreateCategoryRequestBody
): Promise<Category> => {
  return await instance.post(ApiRoutesCategories.MainCategory, body);
};
